<template>
  <div class="order-detail row justify-center">
    <TileBar
      v-if="$q.screen.gt.xs"
      option-button="Back"
      @on-button="$router.go(-1)"
    />
    <div class="col-12 col-sm-10 col-md-9 bg-white">
      <div class="text-center class-title col-12">Order infomation</div>
      <div class="order-id text-center col-12">ID: {{ orderId }}</div>
      <div v-if="!loading" class="row justify-center items-center">
        <!-- <template v-if=""> -->
        <template v-if="!order.payment">
          <template v-if="isExpired">
            <q-icon name="hourglass_empty" style="font-size: 3rem" />
            <div class="text-subtitle2">Expired</div>
            <!-- <q-icon
                            :name="isPaid == true ? `check_circle` : `cancel`"
                            :class="isPaid == true ? `text-green` : `text-red`"
                            style="font-size: 5rem"
                        /> -->
          </template>
          <template v-else>
            <q-icon name="pending_actions" style="font-size: 3rem" class="text-green" />
            <div class="text-subtitle2">Pending</div>
          </template>
        </template>

        <template v-else>
          <template v-if="order.payment.isPaid">
            <q-icon
              name="check_circle"
              class="text-green"
              style="font-size: 3rem"
            />
            <div class="text-subtitle2">Paid</div>
          </template>

          <template v-else>
            <template v-if="isExpired">
              <q-icon name="hourglass_empty" style="font-size: 3rem" />
              <div class="text-subtitle2">Expired</div>
            </template>
            <template v-else>
              <q-icon name="pending_actions" style="font-size: 3rem" class="text-lime" />
              <div class="text-subtitle2">Pending</div>
            </template>
          </template>
        </template>
      </div>

      <div v-if="!loading" class="row justify-end">
        <q-btn-group outline style="margin: 5px 1em">
          <template v-if="isPending">
            <q-btn
              @click="onPayAtStore"
              no-caps
              no-wrap
              color="primary"
              label="Pay at store"
            />
          </template>
          <q-btn
            @click="onPaymentLink"
            no-caps
            no-wrap
            color="primary"
            label="Payment link"
          />
          <q-btn
            no-caps
            no-wrap
            color="primary"
            label="Re-order"
            @click="onReorder"
          />
        </q-btn-group>
      </div>

      <div v-if="!loading" class="shipping-info">
        <tile-bar
          :title="shippingType === 'DELIVERY' ? `Delivery` : `Pick-up`"
        ></tile-bar>
        <div
          class="shipping-detail"
          style="
            margin: 5px 1em;
            padding: 10px;
            border: 1px solid #80808047;
            border-radius: 10px;
          "
        >
          <div class="row">
            <q-icon
              name="location_on"
              style="font-size: 1.6em; padding-right: 10px"
              color="red"
            />
            <span class="col" style="font-weight: bold">{{
              formatedAddress
            }}</span>
          </div>
          <div class="row">
            <q-icon
              name="person"
              style="font-size: 1.6em; padding-right: 10px"
              color="primary"
            />
            <span class="col">{{ formatedContact }}</span>
          </div>
          <div class="row">
            <q-icon
              name="call "
              style="font-size: 1.6em; padding-right: 10px"
              color="primary"
            />
            <span class="col">{{ phoneNumber }}</span>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="payment">
        <tile-bar title="Payment"></tile-bar>
        <div
          class="payment-detail"
          style="
            margin: 5px 1em;
            padding: 10px;
            border: 1px solid #80808047;
            border-radius: 10px;
          "
        >
          <div class="row justify-between">
            <div>Payment method</div>
            <div class="text-primary">
              {{ paymentMethod }}
            </div>
          </div>
          <div class="row justify-between">
            <div>Sub total</div>
            <div class="text-primary">
              {{ subTotal | formattedPrice }}
            </div>
          </div>
          <div class="row justify-between">
            <div>Total delivery fee</div>
            <div class="text-primary">
              {{ deliveryFee | positiveNumber }}
            </div>
          </div>
          <div class="row justify-between">
            <div>Total</div>
            <div class="text-primary text-bold">
              {{ total | formattedPrice }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="order-summary">
        <tile-bar title="Order summary"></tile-bar>
        <div
          class="order-detail"
          style="
            margin: 5px 1em;
            padding: 10px;
            border: 1px solid #80808047;
            border-radius: 10px;
          "
        >
          <div class="col-12">
            <!-- <div class="row justify-between">
                            <div>Order date</div>
                            <div class="text-primary">2 Jul 2021</div>
                        </div> -->
            <!-- <div class="row justify-between">
                            <div>Order status</div>
                            <div class="text-primary">COMPLETE</div>
                        </div> -->
            <div class="column">
              <div>Product list</div>
              <div
                class="text-primary column justify-end"
                style="padding-left: 20px"
              >
                <div
                  class="col-11 row justify-between"
                  v-for="(product, index) in productList"
                  :key="index"
                >
                  <div class="">
                    {{ product.productName }}
                  </div>
                  <div class="">x{{ product.quantity }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <q-dialog v-model="reorderDialog">
      <ReorderDialog />
    </q-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import priceFormat from "@/utils/priceFormat";
import CheckoutCreateOrderSuccess from "@/ui/pages/checkout/CheckoutCreateOrderSuccess";
import PayAtStoreDialog from "@/ui/components/PayAtStoreDialog.vue";
import ReorderDialog from "@/ui/components/ReorderDialog";
import useCart from "@/mixins/useCart";

export default {
  name: "OrderDetail",
  mixins: [useCart],
  components: {
    PayAtStoreDialog,
    CheckoutCreateOrderSuccess,
    ReorderDialog,
    TileBar: () => import(`@/ui/components/TileBar.vue`),
    // DialogAlert: () => import(`@/ui/components/DialogAlert.vue`),
  },
  data() {
    return {
      loading: true,
      order: null,
      rtp: null,
      reorderDialog: false,
    };
  },
  computed: {
    orderId() {
      return this.$route.params.id;
    },
    isExpired() {
      if (this.rtp) {
        const exp = dayjs.unix(this.rtp.expirationTime);
        return dayjs().isAfter(exp);
      }
      return null;
    },
    isPending() {
      if (!this.order.payment) {
        if (this.isExpired) {
          return false;
        } else {
          return true;
        }
      } else {
        if (this.order.payment.isPaid) {
          return false;
        } else {
          if (this.isExpired) {
            return false;
          } else {
            return true;
          }
        }
      }
    },
    shippingType() {
      if (this.order) {
        return this.order.shipping.shippingType;
      }
      return "";
    },
    paymentMethod() {
      if (this.order) {
        if (this.order.payment) {
          if (this.order.payment.paymentMethod) {
            return this.order.payment.paymentMethod;
          }
          return "-";
        }
        return "-";
      }
      return "";
    },
    formatedAddress() {
      if (this.order) {
        if (this.order.shipping) {
          const shipping = this.order.shipping;
          let output = "";
          if (shipping.shippingAddress) {
            output += shipping.shippingAddress;
          }

          if (shipping.shippingSubDistrict) {
            output += " " + shipping.shippingSubDistrict;
          }

          if (shipping.shippingDistrict) {
            output += " " + shipping.shippingDistrict;
          }

          if (shipping.shippingProvince) {
            output += " " + shipping.shippingProvince;
          }

          if (shipping.shippingPostcode) {
            output += " " + shipping.shippingPostcode;
          }

          if (shipping.shippingType == "DELIVERY") {
            if (shipping.shippingLat) {
              output += ` (${shipping.shippingLat}, ${shipping.shippingLon})`;
            }
          }

          return output;
        }
      }
      return "loading...";
      // return "1314 Pak Kret Amphoe Pak Kret Nonthaburi 11120";
    },
    formatedContact() {
      if (this.order) {
        if (this.order.shipping) {
          const shipping = this.order.shipping;
          let output = "";
          if (shipping.shippingFirstName) {
            output += shipping.shippingFirstName;
          }

          if (shipping.shippingLastName) {
            output += " " + shipping.shippingLastName;
          }

          if (shipping.shippingEmail) {
            output += " " + shipping.shippingEmail;
          }

          // if (shipping.shippingPhone) {
          //     output += " " + shipping.shippingPhone;
          // }

          return output;
        }
      }
      return "loading...";
      // return "Fuse Poramet fuse@gmail.com";
    },
    phoneNumber() {
      if (this.order) {
        if (this.order.shipping) {
          return this.order.shipping.shippingPhone;
        }
      }
      return "loading...";
    },
    email() {
      if (this.order) {
        if (this.order.shipping) {
          return this.order.shipping.shippingEmail;
        }
      }
      return null;
    },
    isPaid() {
      if (this.order) {
        if (this.order.payment) {
          return this.order.payment.isPaid;
        }
      }
      return false;
    },
    subTotal() {
      if (this.order) {
        if (this.order.payment) {
          return this.order.payment.subTotal;
        }
        return "-";
      }
      return "loading";
    },
    deliveryFee() {
      if (this.order) {
        if (this.order.payment) {
          return this.order.payment.shippingAmount;
        }
        return "-";
      }
      return "loading";
    },
    total() {
      if (this.order) {
        if (this.order.payment) {
          return this.order.payment.grandTotal;
        }
        return "-";
      }
      return "loading";
    },
    productList() {
      if (this.order) {
        if (this.order.productList) {
          return this.order.productList;
        }
      }
      return [];
    },
  },
  mounted() {
    this.loadOrder();
  },
  methods: {
    async loadOrder() {
      this.loading = true;
      const idToken = await this.$services.authentication.getIdToken();
      this.order = await this.$services.orders.getOrderById(
        this.$route.params.id,
        idToken
      );
      this.rtp = await this.$services.requestToPay.getRequestToPayByOrderID(
        this.$route.params.id
      );
      this.loading = false;
    },
    $priceFormat(value) {
      return priceFormat(value);
    },
    async onReorder() {
      console.log("Confirm reorder");

      //   Please choose customer before adding item.
      const basket = this.$store.state["cart"]["basket"];
      console.log("basket", basket);
      if (!basket) {
        await this.$q
          .dialog({
            title: "Error",
            message: "Please choose customer before reorder.",
          })
          .onOk(() => {
            // console.log('OK')
          })
          .onCancel(() => {
            // console.log('Cancel')
          })
          .onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          });
        return;
      }
      this.$q
        .dialog({
          // title: "Reorder",
          // message: "Add products to your cart",
          component: ReorderDialog,
          cancel: true,
          persistent: true,
          products: this.productList,
        })
        .onOk((list) => {
          console.log(">>>> OK", list);
          list.forEach(async (p) => {
            await this.addToCart(p);
          });
          this.$router.push({ name: "Cart" });
        })
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },
    onPayAtStore() {
      console.log("show pay at store dialog");

      this.$q
        .dialog({
          // title: "Place order success",
          // message: `Order: ${order.orderId}`,
          cancel: true,
          persistent: true,
          component: PayAtStoreDialog,
          // props forwarded to your custom component
          // parent: {
          text: this.rtp.id,
          orderID: this.order.orderId,
          order: this.order,
          // headerText: "Payment Link",
          hideClearCart: true,
          // ...more..props...
          // },
        })
        .onOk(async (payload) => {
          console.log("OK", payload);

          // update order
          const response = await this.$services.pay.payAtStore(
            this.order.orderId,
            payload
          );
          console.log({ response });

          // refresh
          this.loadOrder();
        })
        .onCancel(() => {
          // console.log('Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },
    onPaymentLink() {
      console.log("show payment dialog");

      let phoneNumber = this.phoneNumber;
      if (phoneNumber.startsWith("0")) {
        phoneNumber = phoneNumber.substring(1);
        phoneNumber = "+66" + phoneNumber;
      }

      this.$q
        .dialog({
          // title: "Place order success",
          // message: `Order: ${order.orderId}`,
          cancel: true,
          persistent: true,
          component: CheckoutCreateOrderSuccess,
          // props forwarded to your custom component
          // parent: {
          text: this.rtp.id,
          orderID: this.orderId,
          phoneNumber: phoneNumber,
          email: this.email,
          headerText: "Payment Link",
          hideClearCart: true,
          // ...more..props...
          // },
        })
        .onOk(() => {
          // console.log('OK')

          // clear cart
          this.$store.dispatch("cart/clearBasket");
        })
        .onCancel(() => {
          // console.log('Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },
  },
};
</script>

<style scoped>
.class-title {
  font-size: 18px;
  font-weight: bold;
  padding-top: 10px;
  color: #2c2a74;
}
</style>
